export interface ILocalStorageService {
  get: <V>(key: string) => V | null;
  set: <V>(key: string, value: V) => void;
  remove: (key: string) => void;
}

export default class LocalStorageService implements ILocalStorageService {
  private readonly storage: Storage;

  constructor(storage: Storage) {
    this.storage = storage;
  }

  public get<V>(key: string): V | null {
    const result = this.storage.getItem(key);
    if (!result) {
      return null;
    }
    return JSON.parse(result) as V;
  }

  public set<V>(key: string, value: V): void {
    this.storage.setItem(key, JSON.stringify(value));
  }

  public remove(key: string): void {
    return this.storage.removeItem(key);
  }
}
